import * as React from 'react';
import { ActivityItem, IActivityItemProps, Icon, Link } from '@fluentui/react';
import { mergeStyleSets } from '@fluentui/merge-styles';
import CircleLoader from '../../../../Loader/CircleLoader/CircleLoader';
import { useEffect, useState } from 'react';
import { IProtocol } from '../../../../../shared/interfaces';
import protocolsService from '../../../../../services/protocols.service';
import { RootState } from '../../../../../store';
import { useSelector } from 'react-redux';
import { Log_Operation } from '../../../../../shared/enums';
import Utilities from '../../../../../shared/Utilities/utilities';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const classNames = mergeStyleSets({
    exampleRoot: {
        paddingBottom: '20px',
    },
    nameText: {
        fontWeight: 'bold',
    },
});


export interface StoriaProps {
    protocol: IProtocol
    extraCssClass?: string
}

const Storia: React.FunctionComponent<StoriaProps> = (props) => {

    const selectCurrentAoo = (state: RootState) => state.sessionReducer.currentAoo;
    const currentAoo = useSelector(selectCurrentAoo);
    const selectCurrentUor = (state: RootState) => state.sessionReducer.currentUor;
    const currentUor = useSelector(selectCurrentUor);


    const [loading, setLoading] = useState(false);
    const [activityItems, setActivityItems] = useState<any[]>([])

    useEffect(() => {
        if (props.protocol && currentAoo) {
            protocolsService.getAudit(currentAoo.id, currentUor?.id, props.protocol.id!)
                .then(logs => {
                    let activities: any[] = [];
                    logs.forEach(el => {
                        let message = el.message;
                        let userName = el.username?.split('<')[0];
                        let uor = el.uor;
                        let linkText = userName;
                        if (uor) {
                            linkText += " | " + uor;
                        }
                        let item: IActivityItemProps = {
                            activityDescription: [
                                <Link key={2} className={classNames.nameText}>{linkText}</Link>,
                                <div key={1}>{message}</div>,

                            ],
                            activityIcon: getActivityIcon(el.operation!),
                            timeStamp: getActivityTimeStamp(el.date!),

                        };
                        activities.push({ key: el.id, ...item });
                    });
                    setActivityItems(activities);
                });
        }
    }, [props.protocol, currentAoo]);

    const getActivityIcon = (operation: Log_Operation) => {
        switch (operation) {
            case Log_Operation.register_protocol:
                return (
                    <FontAwesomeIcon icon={['fal', 'file-certificate']} />

                );
            case Log_Operation.create_protocol:
            case Log_Operation.add_attachment:
            case Log_Operation.create_protocol_draft:
            case Log_Operation.add_filing_plan:
            case Log_Operation.add_uor:
            case Log_Operation.add_user_uor:
            case Log_Operation.add_user:
            case Log_Operation.add_undo_request:
                return (
                    <Icon iconName={'Add'} />

                );
            case Log_Operation.update_protocol:
            case Log_Operation.update_user_uor:
            case Log_Operation.update_filing_plan_protocol:
            case Log_Operation.update_visibilita_protocol:
                return (
                    <Icon iconName={'PageEdit'} />

                );
            case Log_Operation.undo_protocol:
            case Log_Operation.approve_undo_request:
                return (
                    <span className={'icomoon-file-certificate-slash-light'}></span>

                );
            case Log_Operation.reload_protocol:

                return (
                    <span className={'icomoon-file-redo-light'}></span>

                );
            case Log_Operation.get_aoo:
            case Log_Operation.get_protocol:
            case Log_Operation.get_attach_protocol:
            case Log_Operation.get_file_protocol:
            case Log_Operation.get_audit_protocol:
            case Log_Operation.get_user_active_aoo:
            case Log_Operation.get_features:
            case Log_Operation.get_feature:
            case Log_Operation.get_fields_by_view_name:
            case Log_Operation.get_fields_by_type:
            case Log_Operation.get_all_fields:
            case Log_Operation.get_lookup_suggestions:
            case Log_Operation.get_protocols_uor:
            case Log_Operation.search_protocols:
            case Log_Operation.get_organization_chart:
            case Log_Operation.get_users_uor:
            case Log_Operation.get_user_info:
            case Log_Operation.get_user_suggestions:
            case Log_Operation.get_roles:
            case Log_Operation.get_user_roles:
            case Log_Operation.get_filing_plan:
            case Log_Operation.get_uors_user_suggestions:
            case Log_Operation.get_print_and_send_spedizioni:
                return (
                    <Icon iconName={'View'} />
                );
            case Log_Operation.delete_user_uor:
            case Log_Operation.delete_attachment:
            case Log_Operation.reject_undo_request:
                return (
                    <Icon iconName={'Trash'} />
                );
            case Log_Operation.send_mail_pecmail:
            case Log_Operation.add_print_and_send:
            case Log_Operation.send_notification:
                return (
                    <Icon iconName={'Send'} />
                );
            case Log_Operation.sign_document:
                return (
                    <FontAwesomeIcon icon={['fal', 'signature']} />
                );

            case Log_Operation.start_processing_protocol_workspace:
                return (
                    <Icon iconName={'Play'} />
                );

            case Log_Operation.assignment_protocol_workspace:
                return (
                    <Icon iconName={'ReminderPerson'} />
                );

            case Log_Operation.end_processing_protocol_workspace:
                return (
                    <Icon iconName={'CheckList'} />
                );

            case Log_Operation.reset_processing_protocol_workspace:
                return (
                    <Icon iconName={'Refresh'} />
                );

            default:
                return (
                    <Icon iconName={'Document'} />
                );


        }
    };
    const getActivityTimeStamp = (date: Date) => {
        return Utilities.FormatDate(date, false);
    };

    return (
        <div className={`storia flex flex-column position-relative ${props.extraCssClass}`}>
            <CircleLoader loaderClass='loader-large' loading={loading} />
            <div className={'my-scroll-div'}>
                <div className={`my-component-content`}>

                    {activityItems.map((item) => (
                        <ActivityItem {...item} key={item.key} className={classNames.exampleRoot} />
                    ))}

                </div>

            </div>

        </ div>

    );
};


export default Storia;





    //const activityItemExamples = [
    //    {
    //        key: 1,
    //        activityDescription: [
    //            <Link
    //                key={1}
    //                className={classNames.nameText}

    //            >
    //                Stefano Capone
    //    </Link>,
    //            <span key={2}> ha inserito una  nota</span>,
    //        ],
    //        activityIcon: <Icon iconName={'Message'} />,
    //        // comments: [
    //        //     <span key={1}>Ha inserito una  nota</span>,
    //        // ],
    //        timeStamp: 'Adesso',
    //    },
    //    {
    //        key: 2,
    //        activityDescription: [
    //            <Link
    //                key={1}
    //                className={classNames.nameText}

    //            >
    //                Stefano Capone
    //    </Link>,
    //            <span key={2}> ha visualizzato il protocollo</span>,
    //        ],
    //        activityIcon: <Icon iconName={'EntryView'} />,
    //        // comments: [
    //        //     <span key={1}>Ha inserito una  nota</span>,
    //        // ],
    //        timeStamp: 'Pochi minuti fa',
    //    },
    //    {
    //        key: 3,
    //        activityDescription: [
    //            <Link
    //                key={1}
    //                className={classNames.nameText}
    //            // onClick={() => {
    //            //     alert('A name was clicked.');
    //            // }}
    //            >
    //                Alessio Magliocco
    //    </Link>,
    //            <span key={2}> ha eliminato </span>,
    //            <span key={3} className={classNames.nameText}>
    //                DocumentTitle.pdf
    //    </span>,
    //        ],
    //        activityIcon: <Icon iconName={'Trash'} />,
    //        timeStamp: '2 ore fa',
    //    },
    //    {
    //        key: 4,
    //        activityDescription: [
    //            <Link
    //                key={1}
    //                className={classNames.nameText}
    //            // onClick={() => {
    //            //     alert('A name was clicked.');
    //            // }}
    //            >
    //                Alessio Magliocco
    //    </Link>,
    //            <span key={2}> ha visualizzato il protocollo</span>,
    //        ],
    //        activityIcon: <Icon iconName={'EntryView'} />,
    //        timeStamp: '2 ore fa',
    //    },
    //    {
    //        key: 5,
    //        activityDescription: [
    //            <Link
    //                key={1}
    //                className={classNames.nameText}

    //            >
    //                Vincenzo Arcella
    //    </Link>,
    //            <span key={2}> ha inserito una  nota</span>,
    //        ],
    //        activityIcon: <Icon iconName={'Message'} />,
    //        // comments: [
    //        //     <span key={1}>Ha inserito una  nota</span>,
    //        // ],
    //        timeStamp: '28/12/2020 16:31',
    //    },
    //    {
    //        key: 6,
    //        activityDescription: [
    //            <Link
    //                key={1}
    //                className={classNames.nameText}

    //            >
    //                Vincenzo Arcella
    //    </Link>,
    //            <span key={2}> ha visualizzato il protocollo</span>,
    //        ],
    //        activityIcon: <Icon iconName={'EntryView'} />,
    //        // comments: [
    //        //     <span key={1}>Ha inserito una  nota</span>,
    //        // ],
    //        timeStamp: '28/12/2020 16:28',
    //    },
    //    {
    //        key: 7,
    //        activityDescription: [
    //            <Link
    //                key={1}
    //                className={classNames.nameText}
    //                onClick={() => {
    //                    alert('A name was clicked.');
    //                }}
    //            >
    //                Francesco Borraccino
    //            </Link>,
    //            <span key={2}> ha creato il protocollo</span>,


    //        ],
    //        activityIcon: <FontAwesomeIcon icon={{ prefix: 'fal', iconName: 'file-plus' }} />,
    //        timeStamp: '28/12/2020 15:49',
    //    },
    //];
